import React, { useState, useEffect } from "react";
import { getRequest } from "../../../service";

const Documents = ({ employeeId }) => {
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  const downloadImage = async (imageUrl, fileName) => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading image:', error);
    }
  };

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        setLoading(true);
        const response = await getRequest(`/api/employees/${employeeId}`);
        if (response.employee) {
          setEmployee(response.employee);
        }
      } catch (error) {
        console.error("Error fetching employee:", error);
      } finally {
        setLoading(false);
      }
    };

    if (employeeId) {
      fetchEmployee();
    }
  }, [employeeId]);

  if (loading) {
    return (
      <div className="w-full rounded-lg flex flex-col gap-2 text-md border-t-[#231564] border-2 border-form-bg px-3 py-3 bg-white text-center">
        Loading documents...
      </div>
    );
  }

  if (!employee) {
    return (
      <div className="w-full rounded-lg flex flex-col gap-2 text-md border-t-[#231564] border-2 border-form-bg px-3 py-3 bg-white text-center">
        No employee data found
      </div>
    );
  }

  return (
    <div className="w-full rounded-lg flex flex-col gap-4 text-md border-t-[#231564] border-2 border-form-bg px-3 py-3 bg-white">
      <h3 className="text-lg font-semibold text-gray-800 mb-2">Employee Documents</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Front Side Image */}
        <div className="flex flex-col items-center">
          <h4 className="text-md font-medium text-gray-700 mb-2">Front Side</h4>
          {employee.frontSideImg ? (
            <div className="w-full max-w-sm">
              <div className="relative group">
                <img 
                  src={employee.frontSideImg} 
                  alt="Front Side Document"
                  className="w-full h-auto rounded-lg border border-gray-300 shadow-sm"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <button
                  onClick={() => downloadImage(employee.frontSideImg, 'front-side-document.jpg')}
                  className="cursor-pointer absolute top-2 right-2 bg-blue-500 hover:bg-blue-600 text-white p-2 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  title="Download Front Side"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </button>
              </div>
              <div className="hidden text-red-500 text-sm mt-1">Image failed to load</div>
            </div>
          ) : (
            <div className="w-full max-w-sm h-48 bg-gray-100 rounded-lg border border-gray-300 flex items-center justify-center">
              <span className="text-gray-500">No front side image available</span>
            </div>
          )}
        </div>

        {/* Back Side Image */}
        <div className="flex flex-col items-center">
          <h4 className="text-md font-medium text-gray-700 mb-2">Back Side</h4>
          {employee.backSideImg ? (
            <div className="w-full max-w-sm">
              <div className="relative group">
                <img 
                  src={employee.backSideImg} 
                  alt="Back Side Document"
                  className="w-full h-auto rounded-lg border border-gray-300 shadow-sm"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <button
                  onClick={() => downloadImage(employee.backSideImg, 'back-side-document.jpg')}
                  className="absolute top-2 right-2 bg-blue-500 hover:bg-blue-600 text-white p-2 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  title="Download Back Side"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </button>
              </div>
              <div className="hidden text-red-500 text-sm mt-1">Image failed to load</div>
            </div>
          ) : (
            <div className="w-full max-w-sm h-48 bg-gray-100 rounded-lg border border-gray-300 flex items-center justify-center">
              <span className="text-gray-500">No back side image available</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Documents;
